import React, { PureComponent } from 'react';
import walkingRouting from 'config/walkingRouting';

import Container from './Container';
import Button from './Button';

class RoutingButtons extends PureComponent {
  state = {
    isOpen: false
  };

  togglePanel = () => {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  };

  render() {
    const { routingEngine } = this.props;

    const { isOpen } = this.state;

    return (
      <Container>
        {isOpen &&
          Object.keys(walkingRouting).map((key) => {
            const onClick = () => {
              this.props.toggleWalkingRoutingEngine(key);
            };

            return (
              <Button
                key={key}
                onClick={onClick}
                isActive={routingEngine === key}
              >
                {walkingRouting[key].name}
              </Button>
            );
          })}
        <Button onClick={this.togglePanel}>
          {isOpen ? 'Close' : 'Walking'}
        </Button>
      </Container>
    );
  }
}

export default RoutingButtons;
